<template>
  <BaseControlBar>
  <!-- <BaseControlBar :back-url="backUrl"> -->
    <div class="flex-grow-1 section-header__title">
      <h1>
        收款狀態
      </h1>
    </div>
    <div class="admin-group" v-if="role === 'admin'">
      <template v-if="isFinished">
        <template v-if="!readOnly">
          <BaseButton variant="outline-secondary" @click="onCancel">取消</BaseButton>
          <BaseButton variant="success" @click="onSubmit">完成</BaseButton>
        </template>
        <template v-else>
          <ButtonEdit @click="onEdit">編輯</ButtonEdit>
          <ButtonRemove
            @click="prepareAction('REMOVE', '你已移除這個紀錄')"
          >
            移除
          </ButtonRemove>
        </template>
      </template>
      <template v-else>
        <BaseButton variant="primary" @click="prepareApprove">確認匯款</BaseButton>
      </template>
      <RecordActionConfirmModal v-model="approval"
                                :onRecordStatusUpdate="onRecordStatusUpdate$"
                                :loading="loading"
      ></RecordActionConfirmModal>
      <WithdrawApproveModal  v-model="inputVal"
                            :modal="withdrawApproveModal"
                            :onWithdrawApprove="onWithdrawApprove$"
                            :readOnly="readOnly"
                            :loading="loading"
      ></WithdrawApproveModal>
      <ActionSuccessModal v-model="actionSuccessModal"></ActionSuccessModal>
    </div>
  </BaseControlBar>
</template>

<script>
import { tap, switchMap } from 'rxjs/operators';
import controlBarMixin from '@/mixins/control-bar';
import BaseControlBar from '@/components/BaseControlBar.vue';
import RecordActionConfirmModal from '@/components/record/RecordActionConfirmModal.vue';
import WithdrawApproveModal from '@/components/record/WithdrawApproveModal.vue';
import ActionSuccessModal from '@/components/ActionSuccessModal.vue';
import http from '../../helpers/http';
import ButtonRemove from '../button/ButtonRemove.vue';
import { getErrorMsg } from '../../helpers/error-msg';
import toastSettings from '../../helpers/toast-settings';

export default {
  mixins: [controlBarMixin],
  components: {
    BaseControlBar,
    ButtonRemove,
    RecordActionConfirmModal,
    ActionSuccessModal,
    WithdrawApproveModal,
  },
  props: {
    validate: {
      type: Function,
    },
    role: String,
    deletedBy: String,
    readOnly: {
      type: Boolean,
    },
    isFinished: Boolean,
  },
  data: () => ({
    approval: {
      modal: false,
      action: null,
      remarks: null,
    },
    loading: false,
    stocksModal: false,
    isEdit: false,
    actionSuccessModal: {
      show: false,
      action: null,
      msg: null,
      back: {
        location: '/admin/paymentRecords',
        text: '返回收款狀態',
      },
    },
    withdrawApproveModal: {
      modal: false,
    },
  }),
  computed: {
    backUrl() {
      return (this.role === 'admin' || this.role === 'sale') ? `/${this.role}/paymentRecords` : '/paymentRecords';
    },
  },
  domStreams: ['onRecordStatusUpdate$', 'onWithdrawApprove$'],
  subscriptions() {
    return {
      recordStatusUpdate: this.onRecordStatusUpdate$.pipe(
        tap(() => {
          this.loading = true;
        }),
        switchMap(() => {
          const { action, msg } = this.approval;
          return http(
            {
              method: 'POST',
              url: `/agc-${this.role}-api/paymentrecord/remove`,
              data: {
                id: this.inputVal.id,
                deletedBy: this.deletedBy,
              },
            },
            {
              next: () => {
                if (msg) {
                  this.actionSuccessModal = {
                    ...this.actionSuccessModal,
                    show: true,
                    action,
                    msg,
                  };
                }
              },
              complete: () => {
                this.approval.modal = false;
                this.loading = false;
              },
            },
          );
        }),
      ),
      withdrawApprove: this.onWithdrawApprove$.pipe(
        switchMap(() => this.validate({ isScrollToTopIfFail: true })),
        tap(() => {
          this.loading = true;
        }),
        switchMap(() => http({
          method: 'POST',
          url: `/agc-${this.role}-api/paymentrecord/approve`,
          data: this.inputVal,
        }, {
          error: ({ data: { msg } }) => {
            this.$bvToast.toast(getErrorMsg(msg), {
              ...toastSettings,
              title: '提交失敗',
              toaster: 'b-toaster-top-center',
            });
          },
          next: () => {
            this.$bvModal.show('coupon-submit-success-modal');
            this.$bvModal.hide('coupon-preview-modal');
          },
          complete: () => {
            this.loading = false;
            this.withdrawApproveModal.modal = false;
            this.inputVal.status = 'FINISHED';
          },
        })),
      ),
    };
  },
  methods: {
    onSubmit() {
      if (this.$route.name === 'AddRecord') {
        this.$emit('submit-click');
      } else {
        this.$emit('resubmit-click');
      }
    },
    async prepareAction(action, msg) {
      this.approval = {
        modal: true,
        action,
        remarks: null,
        msg,
      };
    },
    prepareApprove() {
      this.withdrawApproveModal.modal = true;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .approval-modal {
  &__header {
    border-bottom: none;
  }
}

.admin-group{
  display:flex;
}
</style>
